import { gql } from '@apollo/client';

export const COMMUNICATION_FIELDS = gql`
  fragment CommunicationFields on Communication {
    _id
    to
    type
    method
    scheduledAt
    sentAt
    status
    assessmentId
    ageGroupId
    hasActiveRecipient
    communicationGroup {
      _id
      title
    }
  }
`;

export const REQUEST_EMAILS = gql`
  mutation RequestEmails($email: String!, $types: [String!]!, $operationId: String) {
    requestEmails(email: $email, types: $types, operationId: $operationId)
  }
`;

export const COUNT_HAS_UNSENT_TYPE = gql`
  query CountHasUnsentType($assessmentId: ID!, $ageGroupIds: [ID!]!, $playerAssessmentIds: [ID!], $type: String!) {
    countHasUnsentType(assessmentId: $assessmentId, ageGroupIds: $ageGroupIds, playerAssessmentIds: $playerAssessmentIds, type: $type)
  }
`;

// sessionId is optional: the bulk send-by-age-group paths have no single ice
// time, and only the check-in screen knows which one a confirmation is about.
export const SEND_COMMUNICATION = gql`
  mutation SendCommunication($assessmentId: ID!, $ageGroupIds: [ID!]!, $type: String!, $playerAssessmentIds: [ID!], $sessionId: ID) {
    sendCommunication(assessmentId: $assessmentId, ageGroupIds: $ageGroupIds, type: $type, playerAssessmentIds: $playerAssessmentIds, sessionId: $sessionId)
  }
`;

export const REFRESH_REPORT_CARD_ACCESS_TOKENS = gql`
  mutation RefreshReportCardAccessTokens($playerAssessmentId: ID!) {
    refreshReportCardAccessTokens(playerAssessmentId: $playerAssessmentId)
  }
`;
